// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"4919ef25","407":"31ce3a81","845":"d4b6b59c","889":"e33d9009","923":"685ab896","998":"f24402de"}[chunkId] + ".chunk.js";
};